export default __webpack_public_path__ + "images/47_2_image.jpg";